import {
  ModalDialog,
  ModalDialogActions,
  ModalDialogDescription,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogTitle,
} from '@/components/ModalDialog'
import { Button } from '@/components/Button'

export interface DeleteDocumentDialogProps {
  isOpen: boolean
  onClose?: () => unknown
  isDismissable?: boolean
  documentTitle: string
  isDeletePending?: boolean
  onConfirmDeletePress?: () => unknown
  testId?: string
  deleteButtonTestId?: string
  cancelButtonTestId?: string
}

/**
 * A dialog for confirming the deletion of a document.
 */
export function DeleteDocumentDialog({
  isOpen,
  onClose,
  isDismissable,
  documentTitle,
  isDeletePending,
  onConfirmDeletePress,
  testId,
  deleteButtonTestId,
  cancelButtonTestId,
}: DeleteDocumentDialogProps) {
  return (
    <ModalDialog
      isOpen={isOpen}
      onClose={onClose}
      isDismissable={isDismissable}
      testId={testId}
    >
      <ModalDialogHeader>
        <ModalDialogTitle>Permanently delete?</ModalDialogTitle>
        <ModalDialogDescription>
          Are you sure you want to delete this document? Once "
          <span className="text-headline-md">{documentTitle}</span>" has been
          deleted it may not be recovered.
        </ModalDialogDescription>
      </ModalDialogHeader>
      <ModalDialogFooter>
        <ModalDialogActions>
          <Button
            isPending={isDeletePending}
            label="Permanently delete"
            onPress={onConfirmDeletePress}
            testId={deleteButtonTestId}
          />
          <Button
            isDisabled={isDeletePending}
            variant="outline"
            label="No, cancel"
            onPress={onClose}
            testId={cancelButtonTestId}
          />
        </ModalDialogActions>
      </ModalDialogFooter>
    </ModalDialog>
  )
}
